import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseUpdatePublicCompanyLeadSpecialFee {
  publicCompanyLeadId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdatePublicCompanyLeadSpecialFee = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseUpdatePublicCompanyLeadSpecialFee) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['updatePublicCompanyLeadSpecialFee'],
    mutationFn: async (data: { id: string; target_id?: string; target_type?: string; value?: string }) => {
      const lead = {
        fee_rule_attributes: {
          special_entries_attributes: {
            id: data.id,
            target_id: data.target_id === 'all' ? null : data.target_id,
            target_type: data.target_type,
            value: data.value,
          },
        },
      }

      await privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
